import { THEME_OPTIONS } from '../const'

export const THEME_SELECT_OPTIONS = THEME_OPTIONS.map((option) => ({
  type: 'item' as const,
  value: option.value,
  label: option.label,
}))
